import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AthleteContext } from "./App";

export default function TopNav() {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const path = location.pathname;
    const [topMenuItems, setTopMenuItems] = useState([]);
    const { currentAthlete } = useContext(AthleteContext);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/menu-items/top-menu`)
            .then(res => res.json())
            .then(data => setTopMenuItems(data))
            .catch(console.error);
    }, []);

    // Helper to build href for dynamic content pages
    const makeHref = (item) => item.url || `/content/${item.code}`;

    function toggleMobileMenu() {
        var menu = document.getElementById("mobileMenu");
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    }

    useEffect(() => {
        let lastScrollY = window.scrollY;
        const handleScroll = () => {
            const topbar = document.querySelector('.topbar');
            if (!topbar) return;
            if (window.scrollY > lastScrollY) {
                topbar?.classList?.add('hidden');
            } else {
                topbar?.classList.remove('hidden');
            }
            lastScrollY = window.scrollY;
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isActive = (target) => path === target ? "active-link" : "";
    return (
        <>
            <header className="topbar">
                <div className="header-inner">
                    <div className="header-logo">
                        <a href="/">Hartekind actie 2026</a>
                        {currentAthlete ? (
                            <a className="link" href="/onboarding">Mijn profiel</a>
                        ) : (
                            <a className="link" href="/aanmelden">Aanmelden</a>
                        )}
                        {topMenuItems.map(item => (
                            <a className="link" key={`mobile-menu-${item.code}`} href={makeHref(item)}>
                                {item.menuTitle || item.title}
                            </a>
                        ))}
                    </div>
                    <div className="right-group">
                        <div id="cart-link-container"></div>
                        {path === "/" && (
                            <div className="filter-button" onClick={() => toggleFilterMenu()} >
                                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="3" y1="8" x2="45" y2="8" />
                                    <line x1="3" y1="24" x2="45" y2="24" />
                                    <line x1="3" y1="40" x2="45" y2="40" />
                                    <circle cx="19" cy="8" r="4" fill="#fff" />
                                    <circle cx="32" cy="24" r="4" fill="#fff" />
                                    <circle cx="12" cy="40" r="4" fill="#fff" />
                                </svg>
                            </div>
                        )}
                        <div className="mobile-menu-button" onClick={() => toggleMobileMenu()}>
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="3" y1="5" x2="45" y2="5" />
                                <line x1="3" y1="24" x2="45" y2="24" />
                                <line x1="3" y1="43" x2="45" y2="43" />
                            </svg>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}